if (!customElements.get('gift-property-fields')) {
  customElements.define(
    'gift-property-fields',
    class GiftPropertyFields extends HTMLElement {
      // 選択値が「なし/不要」系かどうか。該当すれば入力欄を隠す。
      static OFF_PATTERN = /(なし|無し|不要|いらない|要らない|しない|付けない|つけない|off)/i;

      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        this.productForm = this.form ? this.form.closest('product-form') : null;
        this.fields = Array.from(this.querySelectorAll('[data-gift-field]'));

        this.update(this.parseInitialOptions());
        this.setupCounter();

        // 入力されたらエラー表示を消す
        this.addEventListener('input', () => this.clearError());

        // 送信時バリデーション。product-form.js のハンドラより先に実行するため、
        // 祖先要素（product-form）のキャプチャフェーズでフックする。
        this.submitTarget = this.productForm || this.form;
        if (this.submitTarget) {
          this.onSubmit = this.onSubmit.bind(this);
          this.submitTarget.addEventListener('submit', this.onSubmit, true);
        }

        // バリアント変更に追従
        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.section) return;
            this.update(event.data.variant.options);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.submitTarget && this.onSubmit) {
          this.submitTarget.removeEventListener('submit', this.onSubmit, true);
        }
      }

      parseInitialOptions() {
        try {
          return JSON.parse(this.dataset.initialOptions || '[]');
        } catch (e) {
          return [];
        }
      }

      // 選択中のバリアントのオプション値配列で各入力欄の表示/有効を切り替える
      update(options) {
        if (!Array.isArray(options)) return;
        this.fields.forEach((field) => {
          const index = Number(field.dataset.optionIndex);
          const on = GiftPropertyFields.isOn(options[index]);
          field.toggleAttribute('hidden', !on);
          field.querySelectorAll('[data-gift-input]').forEach((input) => {
            input.disabled = !on;
          });
          if (!on) this.clearError(field);
        });
      }

      static isOn(value) {
        if (value == null) return false;
        return !GiftPropertyFields.OFF_PATTERN.test(String(value));
      }

      setupCounter() {
        const input = this.querySelector('[data-gift-counter-input]');
        const counter = this.querySelector('[data-gift-counter]');
        if (!input || !counter) return;
        const max = Number(input.getAttribute('maxlength')) || 0;
        const render = () => {
          counter.textContent = Math.max(0, max - input.value.length);
        };
        input.addEventListener('input', render);
        render();
      }

      onSubmit(evt) {
        const invalid = this.fields.find((field) => {
          if (field.hasAttribute('hidden')) return false;
          if (!field.hasAttribute('data-gift-required')) return false;
          const input = field.querySelector('[data-gift-input]');
          return input && !input.disabled && input.value.trim() === '';
        });

        if (!invalid) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.showError(invalid);
        const input = invalid.querySelector('[data-gift-input]');
        if (input) input.focus();
      }

      showError(field) {
        field.classList.add('gift-fields__field--error');
        const message = field.getAttribute('data-gift-error') || 'ご入力ください。';
        const wrapper =
          (this.productForm || document).querySelector('.product-form__error-message-wrapper');
        if (!wrapper) return;
        const messageEl = wrapper.querySelector('.product-form__error-message');
        if (messageEl) messageEl.textContent = message;
        wrapper.removeAttribute('hidden');
      }

      clearError(field) {
        if (field) {
          field.classList.remove('gift-fields__field--error');
        } else {
          this.fields.forEach((f) => f.classList.remove('gift-fields__field--error'));
        }
        const wrapper =
          (this.productForm || document).querySelector('.product-form__error-message-wrapper');
        if (wrapper) wrapper.setAttribute('hidden', '');
      }
    }
  );
}
